/**
 * 格式化數字，添加千位分隔符
 * @param {number|string} number - 要格式化的數字
 * @returns {string|number} 格式化後的數字字串或原值
 */
export default function format_with_substring(number) {
  // 輸入驗證
  if (number === null || number === undefined) {
    console.warn('format_with_substring: 輸入值為 null 或 undefined');
    return 0;
  }
  
  // 轉換為字串並移除空格
  const cleanInput = String(number).trim();
  
  // 檢查是否為空字串
  if (cleanInput === '') {
    console.warn('format_with_substring: 輸入值為空字串');
    return 0;
  }
  
  // 檢查是否為有效數字
  if (isNaN(cleanInput) || cleanInput === 'NaN') {
    console.warn('format_with_substring: 輸入值不是有效數字:', number);
    return number; // 返回原值以保持原有行為
  }
  
  // 特殊情況處理
  if (cleanInput === '0' || parseFloat(cleanInput) === 0) {
    return '0';
  }
  
  try {
    // 將數字轉換為字串並分離整數和小數部分
    const arr = cleanInput.split('.');
    const int = arr[0] || '0';
    const fraction = arr[1] || '';
    
    // 驗證整數部分
    if (!/^-?\d+$/.test(int)) {
      console.warn('format_with_substring: 無效的整數部分:', int);
      return number;
    }
    
    // 驗證小數部分（如果存在）
    if (fraction && !/^\d*$/.test(fraction)) {
      console.warn('format_with_substring: 無效的小數部分:', fraction);
      return number;
    }
    
    // 處理負數
    const isNegative = int.startsWith('-');
    const positiveInt = isNegative ? int.slice(1) : int;
    
    // 格式化整數部分
    const f = positiveInt.length % 3;
    let r = positiveInt.substring(0, f);

    for (let i = 0; i < Math.floor(positiveInt.length / 3); i++) {
      r += ',' + positiveInt.substring(f + i * 3, f + (i + 1) * 3);
    }

    if (f === 0) {
      r = r.substring(1);
    }
    
    // 組合最終結果
    const result = (isNegative ? '-' : '') + r + (fraction ? '.' + fraction : '');
    return result;
    
  } catch (error) {
    console.error('format_with_substring 錯誤:', error, '輸入值:', number);
    return number; // 發生錯誤時返回原值
  }
}

/**
 * 驗證數字格式是否正確
 * @param {any} value - 要驗證的值
 * @returns {boolean} 是否為有效數字
 */
export function isValidNumber(value) {
  if (value === null || value === undefined || value === '') {
    return false;
  }
  
  const num = Number(value);
  return !isNaN(num) && isFinite(num);
}

/**
 * 安全的數字轉換
 * @param {any} value - 要轉換的值
 * @param {number} defaultValue - 預設值
 * @returns {number} 轉換後的數字
 */
export function safeParseNumber(value, defaultValue = 0) {
  if (value === null || value === undefined) {
    return defaultValue;
  }
  
  const cleanValue = String(value).trim();
  if (cleanValue === '') {
    return defaultValue;
  }
  
  const num = Number(cleanValue);
  if (isNaN(num) || !isFinite(num)) {
    console.warn('safeParseNumber: 無法轉換為數字:', value, '使用預設值:', defaultValue);
    return defaultValue;
  }
  
  return num;
}
